@if (tenderDetailsResource.isLoading()) {
  <app-loading />
} @else if (tenderDetailsResource.value()) {
  @let tenderDetails = tenderDetailsResource.value()!;
  <app-wizard-phase-header
    [phase]="'RFQ'"
    [companyName]="tenderDetails.companyName"
    [projectName]="tenderDetails.projectName"
  />

  <p-tabs
    appTabsUnsavedReveal
    [value]="activeTabIndex()"
    (valueChange)="onTabChange($event!)"
    [lazy]="false"
  >
    <p-tablist>
      <p-tab [value]="TAB_INDICES.MAIL_PREVIEW" [appTabStatus]="mailPreviewTabStatus()">
        {{ 'provider.tenderWizard.rfq.mailPreview' | transloco }}
      </p-tab>
      <p-tab
        [value]="TAB_INDICES.PROPOSAL_PARAMETERS"
        [appTabStatus]="proposalParametersTabStatus()"
      >
        {{ 'provider.tenderWizard.rfq.projectParameters' | transloco }}
      </p-tab>
      <p-tab [value]="TAB_INDICES.GUIDANCE" [appTabStatus]="guidanceTabStatus()">
        {{ 'project.steps.rfq.invitationPreview.tab.proposalDocumentsGuidance' | transloco }}
      </p-tab>
      <p-tab [value]="TAB_INDICES.SYSTEM_INTEGRATION" [appTabStatus]="systemIntegrations()">
        {{ 'project.steps.rfq.invitationPreview.tab.systemIntegrations' | transloco }}
      </p-tab>
      @if (canEditDecision()) {
        <p-tab [value]="TAB_INDICES.CONFIRMATION" [appTabStatus]="confirmationTabStatus()">
          {{ 'provider.tenderWizard.confirmation.tabTitle' | transloco }}
        </p-tab>
      }
      <p-tab
        [value]="TAB_INDICES.PRICE_LIST"
        [appTabStatus]="priceListTabStatus()"
        [disabled]="!projectAccepted()"
      >
        {{ 'provider.tenderWizard.previewPriceList' | transloco }}
      </p-tab>
      <p-tab
        [value]="TAB_INDICES.DOCUMENTS"
        [appTabStatus]="documentTabStatus()"
        [disabled]="!projectAccepted()"
      >
        {{ 'provider.tenderWizard.documents' | transloco }}
      </p-tab>
    </p-tablist>

    <p-tabpanels class="mt-6">
      <p-card class="bg-(--p-surface-900) border-none">
        <p-tabpanel [value]="TAB_INDICES.MAIL_PREVIEW">
          <app-tender-invitation-mail
            [tenderDetails]="tenderDetails"
            (nextTab)="onTabChange(TAB_INDICES.PROPOSAL_PARAMETERS)"
          />
        </p-tabpanel>

        <p-tabpanel [value]="TAB_INDICES.PROPOSAL_PARAMETERS">
          <app-tender-project-rfq-proposal-parameters [tenderDetails]="tenderDetails" />
          <div class="flex justify-end mt-6">
            <p-button
              label="{{ 'common.next' | transloco }}"
              (onClick)="onTabChange(TAB_INDICES.GUIDANCE)"
            />
          </div>
        </p-tabpanel>

        <p-tabpanel [value]="TAB_INDICES.GUIDANCE">
          <app-tender-project-rfq-guidance [tenderDetails]="tenderDetails" />
          <div class="flex justify-end mt-6">
            <p-button
              label="{{ 'common.next' | transloco }}"
              (onClick)="onTabChange(TAB_INDICES.SYSTEM_INTEGRATION)"
            />
          </div>
        </p-tabpanel>

        <p-tabpanel [value]="TAB_INDICES.SYSTEM_INTEGRATION">
          <app-tender-project-rfq-proposal-system-integration [tenderDetails]="tenderDetails" />
          <div class="flex justify-end mt-6">
            <p-button
              label="{{ 'common.next' | transloco }}"
              (onClick)="
                onTabChange(canEditDecision() ? TAB_INDICES.CONFIRMATION : TAB_INDICES.PRICE_LIST)
              "
            ></p-button>
          </div>
        </p-tabpanel>

        @if (canEditDecision()) {
          <p-tabpanel [value]="TAB_INDICES.CONFIRMATION">
            <app-tender-decision
              [tenderDetails]="tenderDetails"
              [tenderPhase]="TenderPhaseType.RFQ"
              acceptButtonKey="common.next"
              (accepted)="onTenderAccepted(TAB_INDICES.PRICE_LIST)"
            />
          </p-tabpanel>
        }

        <p-tabpanel [value]="TAB_INDICES.PRICE_LIST">
          <app-subsection-title key="provider.questionnaire.priceList" />
          <app-tender-project-rfq-price-list [tenderId]="tenderId()" />
          <div class="flex justify-end mt-6">
            <p-button
              label="{{ 'common.next' | transloco }}"
              (onClick)="onFinishPriceList(TAB_INDICES.DOCUMENTS)"
            />
          </div>
        </p-tabpanel>

        <p-tabpanel [value]="TAB_INDICES.DOCUMENTS">
          <app-tender-project-rfq-document-upload [tenderId]="tenderId()" />
        </p-tabpanel>
      </p-card>
    </p-tabpanels>
  </p-tabs>
}
